import { render, staticRenderFns } from "./ContentRemoved.vue?vue&type=template&id=4a26e566&scoped=true"
import script from "./ContentRemoved.vue?vue&type=script&lang=js"
export * from "./ContentRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26e566",
  null
  
)

export default component.exports